<template>
  <tr>
    <td style="width: 1.5rem">
      <i
        v-if="draggable"
        class="fas fa-grip-lines"
        style="cursor: grab"
      ></i>
    </td>
    <td>
      <div>#{{ position }}</div>
    </td>
    <td>
      <div>{{ lesson.priority }}</div>
    </td>
    <td>
      <div>{{ lesson.title }}</div>
    </td>
    <td class="center">
      <router-link
        :to="`/app/courses/${courseId}/lessons/${lesson.UUID}/edit`"
        class="btn btn-sm btn-outline-dark m-1"
      >
        <i class="fas fa-edit"></i>
      </router-link>
      <button class="btn btn-sm btn-outline-danger m-1" @click="deleteLesson()">
        <i class="fas fa-trash"></i>
      </button>
    </td>
  </tr>
</template>

<script>
import LessonService from "../../services/lesson.service";
import Swal from "sweetalert2";
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";

export default {
  name: "LessonRow",
  components: {
    QuillEditor,
  },
  props: {
    lesson: Object,
    position: Number,
    courseId: String,
    draggable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      id: this.lesson.UUID,
      updateLesson: {
        title: this.lesson.title,
        subtitle: this.lesson.subtitle,
        description: this.lesson.description,
        videoURL: this.lesson.videoURL,
        priority: this.lesson.priority,
        enabled: this.lesson.enabled,
      },
      file: "",
    };
  },
  methods: {
    async deleteLesson() {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: "¡No podrás revertir esto!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí, borrar!'
        });

        if (result.isConfirmed) {
          await LessonService.deleteLesson(this.lesson.UUID);
          this.$emit('lesson-deleted', this.lesson.UUID); // Emit event to parent
          
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Borrado correctamente",
            showConfirmButton: false,
            timer: 1500,
            toast: true
          });
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No se pudo borrar la lección",
          timer: 2000
        });
      }
    },
  },
  mounted() {
  },
};
</script>
